import React, {useMemo, useState} from 'react'; // Ajout de useState
import {Checkbox, Divider, Select} from "antd";
import {useSelector} from "react-redux";

const MaillerTemplate = ({selectedTemplate, onChange, templates, requete}) => {

	const {parametre, etapesTemplates, renduAs} = useSelector((state) => ({
		parametre: state.parametre.data,
		templatesLangues: state.templatesLangues.data,
		etapesTemplates: state.etapesTemplates.data,
		renduAs: state.renduAs.data,
	}));

	const [showAll, setShowAll] = useState(false);

	const templatesParcoursClient = useMemo(() => {
		const renduA = renduAs.find(
			(item) => item.rendu_a_requete.requete_id === requete?.requete_id && item.rendu_a_actif
		);

		if (renduA === undefined) return [];

		const etapes = etapesTemplates.filter(
			(item) => item.etape_template_etape.etape_id === renduA.rendu_a_etape_id
		);

		return etapes
			.filter((item) => item.etape_template_template.template_type === 1)
			.sort((a, b) => a.etape_template_template.template_libelle.localeCompare(b.etape_template_template.template_libelle))
			.map((item) => ({
				value: item.etape_template_template.template_id,
				label: item.etape_template_template.template_libelle
			}));
	}, [etapesTemplates, renduAs, requete]);

	const templatesFilter = useMemo(() => {
		return templates
			.filter((item) => item.template_type === 1)
			.sort((a, b) => a.template_libelle.localeCompare(b.template_libelle))
			.map((item) => ({
				value: item.template_id,
				label: item.template_libelle
			}));
	}, [templates]);

	const currentOptions = useMemo(() => {
		if (showAll) return templatesFilter;
		return (parametre?.parametre_parcours_client || templatesParcoursClient.length > 0)
			? templatesParcoursClient
			: templatesFilter;
	}, [showAll, templatesFilter, templatesParcoursClient, parametre]);


	return (
		<Select
			size={"large"}
			showSearch
			allowClear
			optionFilterProp="label"
			style={{width: '100%'}}
			value={selectedTemplate}
			onChange={onChange}
			placeholder="Choix Template"
			options={currentOptions} // Utilisation de l'état local ici
			dropdownRender={(menu) => (
				<div>
					{menu}
					<Divider style={{ margin: "4px 0" }} />
					<div style={{ padding: "8px", cursor: "pointer" }}>
						<Checkbox onChange={(e) => setShowAll(e.target.checked)}>Tous les templates</Checkbox>
					</div>
				</div>
			)}
		/>
	);
};

export default MaillerTemplate;